import _functionUncurryThis from "../internals/function-uncurry-this";
var exports = {};
var uncurryThis = _functionUncurryThis;
var toString = uncurryThis({}.toString);
var stringSlice = uncurryThis("".slice);
exports = function (it) {
  return stringSlice(toString(it), 8, -1);
};
export default exports;